
import { changeMyProfilePopupVisibility, changePopupVisibility } from '../actions/ControlsAction'
import { getPlayerData, getAccountWallets } from '../actions/UserActions';
//Enums
import { PopupEnum, popupHashes, myProfileFormStates } from '../components/base/PopupEnum';
import { CashierEnum } from '../components/myProfile/payments/enums/CashierEnum';
import { ProfileEnum } from '../components/myProfile/payments/enums/ProfileEnum';
import { OfferMenuEnum } from '../components/myProfile/offers/OfferMenuEnum';
import { DepositEnum } from '../components/myProfile/payments/enums/DepositEnum';
import { WithdrawalEnum } from '../components/myProfile/payments/enums/WithdrawalEnum';
import { Auth } from '../services/Auth';
import store from '../index';
import { matchPath } from 'react-router-dom'
import { RoutePath } from '../constants/SitePaths';
import Utils from '../services/Utils';
import config from '../constants/Configs';
import ResponsibleGamingEnum from './myProfile/responsibleGaming/ResponsibleGamingEnum';
import { AgentEnum } from './base/AgentEnum';
import NewOfferMenuEnum from './myProfile/offers/bonuses/NewOfferMenuEnum';
import BonusesEnum from './myProfile/offers/bonuses/BonusesEnum';
import { hideCustomPopup } from '../actions/PopupAction';
import SecurityEnum from './myProfile/payments/enums/SecurityEnum';
import { ReferFriendEnum } from './myProfile/offers/referFriend/ReferFriendEnum';

const PopupListener = {
    historyListener: (history, location, action, withClosePopup) => {
        let endPart;
        try {
            endPart = decodeURIComponent(location.pathname).split('/popup/')[1] || '';
        } catch (error) {
            endPart = location.pathname.split('/popup/')[1] || '';
        }

        const popupName = endPart ? endPart.split('/')[0] : '';
        PopupListener.openPopup(history, popupName, action, withClosePopup);
    },
    openPopup: (history, popupName, action, withClosePopup) => {
        const locationHash = popupName && 'popup/' + popupName;
        const selectedSubTab = store.getState().ui.selectedSubTab;
        const popupVisible = store.getState().ui.popupVisible;
        const multiSignInEnabled = store.getState()?.settings?.multiSignInEnabled;
        const showTrustedDevicesTab = store.getState()?.settings?.showTrustedDevicesTab;
        const activePromoCode = store.getState()?.settings?.bonusSettings?.promoCodeEnabled;
        const activePrizesHistory = store.getState()?.settings?.bonusSettings?.prizesHistoryEnabled || true;
        const twoFactorAuthEnabled = store.getState()?.settings?.twoFactorAuthEnabled;
        const twoFALogin = store.getState()?.settings?.features?.twoFALogin;
        const popupKey = Object.keys(PopupEnum).find(key => key.toLowerCase() === popupName)
        const player = store.getState().user.playerData.player;
        const showPreferencesTab = store.getState()?.settings?.showPreferencesTab;
        switch (locationHash) {
            case popupHashes.login.val:
            case popupHashes.join.val:
            case popupHashes.registration.val:
            case popupHashes.forgotpassword.val:
            case popupHashes.forgotusername.val:
                if (!Auth.isAuthenticated() && popupVisible !== PopupEnum[popupKey]) {
                    store.dispatch(changePopupVisibility(PopupEnum[popupKey]));
                }
                if (Auth.isAuthenticated()) {
                    store.dispatch(changePopupVisibility(PopupEnum.Close));
                    Utils.removeOverflowHidden();
                    const pathnParts = decodeURIComponent(history.location.pathname).split('/popup/');
                    const locationPath = pathnParts[0].endsWith("/") ? pathnParts[0] : pathnParts[0] + '/';
                    const newURL = locationPath.replace(/\/$/, '') + window.location.search;
                    history.replace(newURL);
                }
                break;
            case popupHashes.cashier.val:
                PopupListener.openPoup(popupName, popupKey);
                break;
            case popupHashes.accountmenu.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum[popupKey]));
                } else {
                    store.dispatch(changePopupVisibility(PopupEnum.Close));
                }
                break;

            case popupHashes.cupisotp.val:
            case popupHashes.gamehistory.val:
            case popupHashes.referrerreport.val:
            case popupHashes.messages.val:
            case popupHashes.requestcallback.val:
            case popupHashes.requestcashback.val:
                PopupListener.openPoup(popupName, popupKey);
                break;
            case popupHashes.myprofile.val:
                if (config.ENV !== 'tst-cnt' && config.ENV !== 'prod-cnt-prdeu') {
                    store.dispatch(getAccountWallets());
                }
                PopupListener.openPoup(popupName, popupKey);
                break;
            case popupHashes.changepassword.val:
                if (!(selectedSubTab && selectedSubTab.myProfileFormState) || action === 'call') {
                    store.dispatch(changePopupVisibility(PopupEnum[popupKey]));
                } else if (!Auth.isAuthenticated()) {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.documents.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.Documents,
                        subTab: 0
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.identification.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.Identification,
                        subTab: 0
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;

            case popupHashes.twoFactorAuth.val:
                if (Auth.isAuthenticated()) {
                    if (twoFactorAuthEnabled || twoFALogin) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.Security,
                            subTab: SecurityEnum.TwoFactor
                        }));
                    } else {
                        store.dispatch(changeMyProfilePopupVisibility(false))
                    }
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.trustedbrowsers.val:
                if (Auth.isAuthenticated()) {
                    if (showTrustedDevicesTab) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.Security,
                            subTab: SecurityEnum.TrustedBrowsers
                        }));
                    } else {
                        store.dispatch(changeMyProfilePopupVisibility(false))
                    }
                }
                else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.accountsecurity.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.Security,
                        subTab: SecurityEnum.AccountSecurity
                    }));
                }
                else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.activesessions.val:
                if (Auth.isAuthenticated()) {
                    // if (multiSignInEnabled) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.Security,
                        subTab: SecurityEnum.ActiveSessions
                    }));
                    // } else {
                    //     store.dispatch(changeMyProfilePopupVisibility(false))
                    // }
                }
                else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.activitylog.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.Security,
                        subTab: SecurityEnum.ActivityLog
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.passkey.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.Security,
                        subTab: SecurityEnum.Passkey
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.preferences.val:
                if (!showPreferencesTab) {
                    store.dispatch(changePopupVisibility(PopupEnum.Close));
                    break;
                }
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.Preferences,
                        subTab: 0
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.responsibleGaming.val:
                if (config.NEW_PLAT) {
                    if (Auth.isAuthenticated()) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.ResponsibleGaming,
                            subTab: null
                        }));
                    } else {
                        PopupListener.openLoginPopupWithHash(popupName);
                    }
                }
                break;
            case popupHashes.accountClosure.val:
                if (config.NEW_PLAT) {
                    if (Auth.isAuthenticated()) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.ResponsibleGaming,
                            subTab: ResponsibleGamingEnum.AccountClosureSection
                        }));
                    } else {
                        PopupListener.openLoginPopupWithHash(popupName);
                    }
                }
                break;
            case popupHashes.accessLimit.val:
                if (config.NEW_PLAT) {
                    if (Auth.isAuthenticated()) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.ResponsibleGaming,
                            subTab: ResponsibleGamingEnum.AccessLimitSection
                        }));
                    } else {
                        PopupListener.openLoginPopupWithHash(popupName);
                    }
                }
                break;
            case popupHashes.timeLimit.val:
                if (config.NEW_PLAT) {
                    if (Auth.isAuthenticated()) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.ResponsibleGaming,
                            subTab: ResponsibleGamingEnum.TimeLimitSection
                        }));
                    } else {
                        PopupListener.openLoginPopupWithHash(popupName);
                    }
                }
                break;
            case popupHashes.depositLimit.val:
                if (player && player.agentType === AgentEnum.Player) {
                    store.dispatch(changePopupVisibility(PopupEnum.Close));
                    break;
                }
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.ResponsibleGaming,
                        subTab: ResponsibleGamingEnum.DepositLimitSection
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.betLimit.val:
                if (config.NEW_PLAT) {
                    if (Auth.isAuthenticated()) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.ResponsibleGaming,
                            subTab: ResponsibleGamingEnum.BetLimitSection
                        }));
                    } else {
                        PopupListener.openLoginPopupWithHash(popupName);
                    }
                }
                break;
            case popupHashes.selfExclusion.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.ResponsibleGaming,
                        subTab: ResponsibleGamingEnum.SelfExclusionSection
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.realityChecks.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.ResponsibleGaming,
                        subTab: ResponsibleGamingEnum.RealityCheckSection
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.timeOut.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.ResponsibleGaming,
                        subTab: ResponsibleGamingEnum.TimeOutSection
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.nsep.val:
                if (config.NEW_PLAT) {
                    if (Auth.isAuthenticated()) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.ResponsibleGaming,
                            subTab: ResponsibleGamingEnum.NsepSection
                        }));
                    } else {
                        PopupListener.openLoginPopupWithHash(popupName);
                    }
                }
                break;
            case popupHashes.lossLimit.val:
                if (config.NEW_PLAT) {
                    if (Auth.isAuthenticated()) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                            tab: ProfileEnum.ResponsibleGaming,
                            subTab: ResponsibleGamingEnum.LossLimitSection
                        }));
                    } else {
                        PopupListener.openLoginPopupWithHash(popupName);
                    }
                }
                break;

            case popupHashes.promocodes.val:
                if (Auth.isAuthenticated()) {
                    if (activePromoCode) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                            tab: OfferMenuEnum.PromoCodes,
                            subTab: 0
                        }));
                    } else {
                        store.dispatch(changeMyProfilePopupVisibility(false))
                    }
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.sporttournaments.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.SportTournaments,
                        subTab: 0
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.tournamenthistory.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.TournamentHistory,
                        subTab: 0
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());

                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.bonusesV2.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.NewOffers,
                        subTab: 0
                    }));
                    store.dispatch(getAccountWallets());
                    store.dispatch(getPlayerData());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.newBonusesV2.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.NewOffers,
                        subTab: 1
                    }));
                    store.dispatch(getAccountWallets());
                    store.dispatch(getPlayerData());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.casinobonuses.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.NewOffers,
                        subTab: NewOfferMenuEnum.Casino
                    }));
                    store.dispatch(getAccountWallets());
                    store.dispatch(getPlayerData());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.offers.val:
            case popupHashes.sportbonuses.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.NewOffers,
                        subTab: NewOfferMenuEnum.Sport
                    }));
                    store.dispatch(getAccountWallets());
                    store.dispatch(getPlayerData());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.freespins.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.NewOffers,
                        subTab: NewOfferMenuEnum.FreeSpins
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.wallet.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changePopupVisibility(PopupEnum.Wallet));
                }
                break;
            case popupHashes.realmoneybonuses.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.NewOffers,
                        subTab: NewOfferMenuEnum.RealMoney
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.inviteFriend.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.ReferFriend,
                        subTab: ReferFriendEnum.InviteFriend
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.statusTracking.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.ReferFriend,
                        subTab: ReferFriendEnum.StatusTracking
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.bonuses.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.Bonuses,
                        subTab: BonusesEnum.Bonuses
                    }));
                    store.dispatch(getAccountWallets());
                    store.dispatch(getPlayerData());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.bonushistory.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.BonusHistory,
                        subTab: BonusesEnum.BonusHistory
                    }));
                    store.dispatch(getAccountWallets());
                    store.dispatch(getPlayerData());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.prizeshistory.val:
                if (Auth.isAuthenticated()) {
                    if (activePrizesHistory) {
                        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                            tab: OfferMenuEnum.PrizesHistory,
                            subTab: 0
                        }));
                        store.dispatch(getAccountWallets());
                        store.dispatch(getPlayerData());
                    } else {
                        store.dispatch(changeMyProfilePopupVisibility(false))
                    }
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.campaign.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Offers, {
                        tab: OfferMenuEnum.Campaign,
                        subTab: OfferMenuEnum.Campaign
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.deposithistory.val:
                if (Auth.isAuthenticated()) {
                    if (player && player.agentType === AgentEnum.Player) {
                        store.dispatch(changePopupVisibility(PopupEnum.Close));
                        break;
                    }
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Cashier, {
                        tab: CashierEnum.Deposit,
                        subTab: DepositEnum.History
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.withdrawalhistory.val:
                if (Auth.isAuthenticated()) {
                    if (player && player.agentType === AgentEnum.Player) {
                        store.dispatch(changePopupVisibility(PopupEnum.Close));
                        break;
                    }
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Cashier, {
                        tab: CashierEnum.Withdrawal,
                        subTab: WithdrawalEnum.History
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.withdrawal.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Cashier, {
                        tab: CashierEnum.Withdrawal,
                        subTab: WithdrawalEnum.Methods
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.cashiersettings.val:
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Cashier, {
                        tab: CashierEnum.IframeSettings,
                        subTab: 0
                    }));
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.transaction.val:
                const russianServiceValidation = store.getState().settings?.plugins?.russianServiceValidation || store.getState().settings?.plugins?.russianServiceValidation2;
                if (russianServiceValidation) {
                    store.dispatch(changePopupVisibility(PopupEnum.Close))
                }
                else if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.Cashier, {
                        tab: CashierEnum.Transaction,
                        subTab: 0
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());
                } else {
                    PopupListener.openLoginPopupWithHash(popupName);
                }
                break;
            case popupHashes.promotions.val:
            case popupHashes.custom.val:
                store.dispatch(changePopupVisibility(PopupEnum[popupKey]));
                break;
            default:
                if (withClosePopup) {
                    store.dispatch(hideCustomPopup())
                    store.dispatch(changePopupVisibility(PopupEnum.Close))
                }
                break;
        }
    },
    openPoup(popupName, popupKey) {
        if (Auth.isAuthenticated()) {
            store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum[popupKey]));
            // store.dispatch(getPlayerData());
            // store.dispatch(getAccountWallets());
        } else {
            PopupListener.openLoginPopupWithHash(popupName);
        }
    },
    openLoginPopupWithHash: (popupName) => {
        store.dispatch(changePopupVisibility({ selectedTab: PopupEnum.Login, callback: popupName }));
    },
    handlePopupVisibleChange: (pathName, popupVisible, selectedSubTab, location, history) => {
        const { tab, subTab, myProfileFormState, data } = selectedSubTab ? selectedSubTab : {};
        const params = PopupListener.matchPopupParams(pathName);
        const popupId = params.id ? params.id : '';
        const pathnParts = decodeURIComponent(location.pathname).split('/popup/');
        const popupName = params.popupName ? 'popup/' + params.popupName : '';
        const locationPath = pathnParts[0].endsWith("/") ? pathnParts[0] : pathnParts[0] + '/';
        const popup = pathnParts[1];
        const isCasinoEnabled = store.getState()?.settings?.isCasinoEnabled
        const isBonusVersion2Enabled = store.getState()?.settings?.isBonusVersion2Enabled;

        switch (popupVisible) {
            case PopupEnum.Registration:
                if (popupName !== popupHashes.registration.val) {
                    // let referId = windowHash.split('#')[2] || '';
                    // referId = referId ? '#' + referId : referId;
                    history.push(locationPath + popupHashes.registration.val + popupId) //+ referId
                }
                break;
            case PopupEnum.RecoverPassword:
                break;
            case PopupEnum.Login:
                if (popupName !== popupHashes.login.val) {
                    // let redirectPath = windowHash.split('#')[2] || '';
                    // redirectPath = redirectPath ? '#' + redirectPath : redirectPath;
                    history.push(locationPath + popupHashes.login.val + popupId) //+ redirectPath
                }
                break;
            case PopupEnum.AccountMenu:
                if (popupName !== popupHashes.accountmenu.val) {
                    history.push(locationPath + popupHashes.accountmenu.val)
                }
                break;
            case PopupEnum.ForgotPassword:
                if (popupName !== popupHashes.forgotpassword.val) {
                    history.push(locationPath + popupHashes.forgotpassword.val)
                }
                break;
            case PopupEnum.RecoverPasswordSuccess:
                break;
            case PopupEnum.ForgotUsername:
                if (popupName !== popupHashes.forgotusername.val) {
                    history.push(locationPath + popupHashes.forgotusername.val)
                }
                break;
            case PopupEnum.ForgotUsernameSuccess:
                break;
            case PopupEnum.ChangePassword:
                if (popupName !== popupHashes.changepassword.val) {
                    history.push(locationPath + popupHashes.changepassword.val)
                }
                break;
            case PopupEnum.ChangePasswordSuccess:
                break;
            case PopupEnum.RegistartionFormSuccess:
            case PopupEnum.OneClickRegistartionFormSuccess:
                break;
            case PopupEnum.Wallet:
                if (popupName !== popupHashes.wallet.val) {
                    history.push(locationPath + popupHashes.wallet.val + (selectedSubTab ? '/' + selectedSubTab : ''))
                }
                break;
            case PopupEnum.MyProfile:
                switch (tab) {
                    case ProfileEnum.MyProfile:
                        if (popupName !== popupHashes.myprofile.val) {
                            !myProfileFormState && history.push(locationPath + popupHashes.myprofile.val)
                        } else {
                            myProfileFormState === myProfileFormStates.changePasswordForm && history.push(locationPath + popupHashes.changepassword.val)
                        }
                        break;
                    case ProfileEnum.Documents:
                        if (popupName !== popupHashes.documents.val) {
                            history.push(locationPath + popupHashes.documents.val)
                        }
                        break;
                    case ProfileEnum.Identification:
                        if (popupName !== popupHashes.identification.val) {
                            history.push(locationPath + popupHashes.identification.val)
                        }
                        break;
                    case ProfileEnum.Security:
                        switch (subTab) {
                            case SecurityEnum.TwoFactor:
                                if (popupName !== popupHashes.twoFactorAuth.val) {
                                    history.push(locationPath + popupHashes.twoFactorAuth.val)
                                }
                                break;
                            case SecurityEnum.ActiveSessions:
                                if (popupName !== popupHashes.activesessions.val) {
                                    history.push(locationPath + popupHashes.activesessions.val)
                                }
                                break;
                            case SecurityEnum.TrustedBrowsers:
                                if (popupName !== popupHashes.trustedbrowsers.val) {
                                    history.push(locationPath + popupHashes.trustedbrowsers.val)
                                }
                                break;
                            case SecurityEnum.ActivityLog:
                                if (popupName !== popupHashes.activitylog.val) {
                                    history.push(locationPath + popupHashes.activitylog.val)
                                }
                                break;
                            case SecurityEnum.AccountSecurity:
                                if (popupName !== popupHashes.accountsecurity.val) {
                                    history.push(locationPath + popupHashes.accountsecurity.val)
                                }
                                break;
                            case SecurityEnum.Passkey:
                                if (popupName !== popupHashes.passkey.val) {
                                    history.push(locationPath + popupHashes.passkey.val)
                                }
                                break
                            default:
                                break;
                        }
                        break;
                    case ProfileEnum.ActivityLog:
                        if (popupName !== popupHashes.activitylog.val) {
                            history.push(locationPath + popupHashes.activitylog.val)
                        }
                        break;
                    case ProfileEnum.Passkey:
                        if (popupName !== popupHashes.passkey.val) {
                            history.push(locationPath + popupHashes.passkey.val)
                        }
                        break;
                    case ProfileEnum.Preferences:
                        if (popupName !== popupHashes.preferences.val) {
                            history.push(locationPath + popupHashes.preferences.val)
                        }
                        break;
                    case ProfileEnum.ResponsibleGaming:
                        switch (subTab) {
                            case ResponsibleGamingEnum.DepositLimitSection:
                                if (popupName !== popupHashes.depositLimit.val) {
                                    history.push(locationPath + popupHashes.depositLimit.val)
                                }
                                break;
                            case ResponsibleGamingEnum.TimeOutSection:
                                if (popupName !== popupHashes.timeOut.val) {
                                    history.push(locationPath + popupHashes.timeOut.val)
                                }
                                break;
                            case ResponsibleGamingEnum.SelfExclusionSection:
                                if (popupName !== popupHashes.selfExclusion.val) {
                                    history.push(locationPath + popupHashes.selfExclusion.val)
                                }
                                break;
                            case ResponsibleGamingEnum.NsepSection:
                                if (popupName !== popupHashes.nsep.val) {
                                    history.push(locationPath + popupHashes.nsep.val)
                                }
                                break;
                            case ResponsibleGamingEnum.RealityCheckSection:
                                if (popupName !== popupHashes.realityChecks.val) {
                                    history.push(locationPath + popupHashes.realityChecks.val)
                                }
                                break;
                            case ResponsibleGamingEnum.BetLimitSection:
                                if (popupName !== popupHashes.betLimit.val) {
                                    history.push(locationPath + popupHashes.betLimit.val)
                                }
                                break;
                            case ResponsibleGamingEnum.AccountClosureSection:
                                if (popupName !== popupHashes.accountClosure.val) {
                                    history.push(locationPath + popupHashes.accountClosure.val)
                                }
                                break
                            case ResponsibleGamingEnum.AccessLimitSection:
                                if (popupName !== popupHashes.accessLimit.val) {
                                    history.push(locationPath + popupHashes.accessLimit.val)
                                }
                                break
                            case ResponsibleGamingEnum.TimeLimitSection:
                                if (popupName !== popupHashes.timeLimit.val) {
                                    history.push(locationPath + popupHashes.timeLimit.val)
                                }
                                break
                            case ResponsibleGamingEnum.LossLimitSection:
                                if (popupName !== popupHashes.lossLimit.val) {
                                    history.push(locationPath + popupHashes.lossLimit.val)
                                }
                                break
                            default:
                                break;
                        }
                        break;
                    default:
                        if (popupName !== popupHashes.myprofile.val) {
                            history.push(locationPath + popupHashes.myprofile.val)
                        }
                        break;
                }
                break;
            case PopupEnum.Cashier:
                switch (tab) {
                    case CashierEnum.Deposit:
                        switch (subTab) {
                            case DepositEnum.Methods:
                                if (popupName !== popupHashes.cashier.val + (data ? '/' + data : '')) {
                                    history.push(locationPath + popupHashes.cashier.val + (data ? '/' + data : ''))
                                }
                                break;
                            case DepositEnum.History:
                                if (popupName !== popupHashes.deposithistory.val) {
                                    history.push(locationPath + popupHashes.deposithistory.val)
                                }
                                break;
                            default:
                                break;
                        }
                        break;
                    case CashierEnum.Withdrawal:
                        switch (subTab) {
                            case WithdrawalEnum.Methods:
                                if (popupName !== popupHashes.withdrawal.val) {
                                    history.push(locationPath + popupHashes.withdrawal.val)
                                }
                                break;
                            case WithdrawalEnum.History:
                                if (popupName !== popupHashes.withdrawalhistory.val) {
                                    history.push(locationPath + popupHashes.withdrawalhistory.val)
                                }
                                break;
                            default:
                                break;
                        }
                        break;
                    case CashierEnum.Transaction:
                        if (popupName !== popupHashes.transaction.val) {
                            history.push(locationPath + popupHashes.transaction.val)
                        }

                        break;
                    case CashierEnum.IframeSettings:
                        if (popupName !== popupHashes.cashiersettings.val) {
                            history.push(locationPath + popupHashes.cashiersettings.val)
                        }
                        break;
                    default:
                        if (popupName !== popupHashes.cashier.val + (data ? '/' + data : '')) {
                            history.push(locationPath + popupHashes.cashier.val + (data ? '/' + data : ''))
                        }
                        break;
                }
                break;
            case PopupEnum.Offers:
                switch (tab) {
                    case OfferMenuEnum.NewOffers:
                        if (isBonusVersion2Enabled) {
                            switch (subTab) {
                                case 0:
                                    if (popupName !== popupHashes.bonusesV2.val) {
                                        history.push(locationPath + popupHashes.bonusesV2.val)
                                    }
                                    break;
                                case 1:
                                    if (popupName !== popupHashes.newBonusesV2.val) {
                                        history.push(locationPath + popupHashes.newBonusesV2.val)
                                    }
                                    break;

                                default:
                                    if (popupName !== popupHashes.bonusesV2.val) {
                                        history.push(locationPath + popupHashes.bonusesV2.val)
                                    }
                                    break;
                            }
                            break;
                        } else {
                            switch (subTab) {
                                case NewOfferMenuEnum.Casino:

                                    if (popupName !== popupHashes.casinobonuses.val) {
                                        history.push(locationPath + popupHashes.casinobonuses.val)
                                    }
                                    break;
                                case NewOfferMenuEnum.Sport:
                                    if (popupName !== popupHashes.sportbonuses.val) {
                                        history.push(locationPath + popupHashes.sportbonuses.val)
                                    }
                                    break;
                                case NewOfferMenuEnum.FreeSpins:
                                    if (popupName !== popupHashes.freespins.val) {
                                        history.push(locationPath + popupHashes.freespins.val)
                                    }
                                    break;
                                case NewOfferMenuEnum.RealMoney:
                                    if (popupName !== popupHashes.realmoneybonuses.val) {
                                        history.push(locationPath + popupHashes.realmoneybonuses.val)
                                    }
                                    break;
                                default:
                                    break;
                            }
                        }

                        break;
                    case OfferMenuEnum.Bonuses:
                        switch (subTab) {
                            case BonusesEnum.Bonuses:
                                if (popupName !== popupHashes.bonuses.val) {
                                    history.push(locationPath + popupHashes.bonuses.val)
                                }
                                break;
                            default:
                                break;
                        }
                        break;
                    case OfferMenuEnum.Campaign:
                        if (popupName !== popupHashes.campaign.val) {
                            history.push(locationPath + popupHashes.campaign.val)
                        }
                        break;
                    case OfferMenuEnum.ReferFriend:
                        switch (subTab) {
                            case ReferFriendEnum.InviteFriend:
                                if (popupName !== popupHashes.inviteFriend.val) {
                                    history.push(locationPath + popupHashes.inviteFriend.val)
                                }
                                break;
                            case ReferFriendEnum.StatusTracking:
                                if (popupName !== popupHashes.statusTracking.val) {
                                    history.push(locationPath + popupHashes.statusTracking.val)
                                }
                                break;
                            default:
                                break;
                        }

                        break;
                    case OfferMenuEnum.SportTournaments:
                        if (popupName !== popupHashes.sporttournaments.val) {
                            history.push(locationPath + popupHashes.sporttournaments.val)
                        }
                        break;
                    case OfferMenuEnum.TournamentHistory:
                        if (popupName !== popupHashes.tournamenthistory.val) {
                            history.push(locationPath + popupHashes.tournamenthistory.val)
                        }
                        break;
                    case OfferMenuEnum.PromoCodes:
                        if (popupName !== popupHashes.promocodes.val) {
                            history.push(locationPath + popupHashes.promocodes.val)
                        }
                        break;
                    case OfferMenuEnum.BonusHistory:
                        if (popupName !== popupHashes.bonushistory.val) {
                            history.push(locationPath + popupHashes.bonushistory.val)
                        }
                        break;
                    case OfferMenuEnum.PrizesHistory:
                        if (popupName !== popupHashes.prizeshistory.val) {
                            history.push(locationPath + popupHashes.prizeshistory.val)
                        }
                        break;
                    default:
                        if (popupName !== popupHashes.offers.val) {
                            history.push(locationPath + popupHashes.offers.val)
                        }
                        break;
                }
                break;
            case PopupEnum.Messages:
                if (popupName !== popupHashes.messages.val) {
                    history.push(locationPath + popupHashes.messages.val)
                }
                break;
            case PopupEnum.GameHistory:
                if (config.NEW_PLAT && !isCasinoEnabled) {
                    store.dispatch(changePopupVisibility(PopupEnum.Close));
                }
                if (popupName !== popupHashes.gamehistory.val) {
                    history.push(locationPath + popupHashes.gamehistory.val)
                }
                break;
            case PopupEnum.ReferrerReport:
                if (popupName !== popupHashes.referrerreport.val) {
                    history.push(locationPath + popupHashes.referrerreport.val)
                }
                break;
            case PopupEnum.Promotions:
                if (popupName !== popupHashes.promotions.val) {
                    history.push(locationPath + popupHashes.promotions.val + popupId)
                }
                break;
            case PopupEnum.Ad:
                if (popupName !== popupHashes.custom.val) {
                    history.push(locationPath + popupHashes.custom.val + '/' + selectedSubTab)
                }
                break;
            case PopupEnum.Join:
                if (popupName !== popupHashes.custom.val) {
                    history.push(locationPath + popupHashes.join.val)
                }
                break;
            case PopupEnum.RequestCallback:
                if (popupName !== popupHashes.requestcallback.val) {
                    history.push(locationPath + popupHashes.requestcallback.val)
                }
                break;
            case PopupEnum.RequestCashBack:
                if (popupName !== popupHashes.requestcashback.val) {
                    history.push(locationPath + popupHashes.requestcashback.val)
                }
                break;
            case PopupEnum.CupisOTP:
                if (popupName !== popupHashes.cupisotp.val) {
                    history.push(locationPath + popupHashes.cupisotp.val)
                }
                break;
            case PopupEnum.MobileProfileMenu:
                break;
            default:
                Utils.removeOverflowHidden();
                const params = new URLSearchParams(window.location.search);
                params.delete("amount");
                const newQuery = params.toString();
                const newUrl = locationPath.replace(/\/$/, '') + newQuery;
                popup === 'login' || popup === 'registration' ? history.replace(newUrl) : history.push(newUrl);
                break;
        }
    },
    getParams: (matchProps) => {
        const { location, match } = matchProps;
        const newMatch = matchPath(location.pathname, {
            path: match.path.replace("/(popup)?", "/popup"),
            exact: false,
            strict: false
        });
        return {
            ...matchProps,
            match: newMatch || match
        }
    },
    matchPopupParams: (pathname) => {
        const newMatch = matchPath(pathname, {
            path: RoutePath.POPUP,
            exact: false,
            strict: false
        });
        return newMatch ? newMatch.params : {};
    }
}
export default PopupListener;
